let available: Promise<boolean> | null = null;
/**
 * 読み合わせサーバーか（tailnet の読み合わせサーバーだけ true。本番は /api/story-review が 404）。
 * 読み合わせサーバーでは物語の本編を未読も含めて全部読める。台詞へのメモ（開発用）は本番に向けて外した
 */
export const reviewAvailable = () =>
  (available ??= fetch('/api/story-review', { credentials: 'same-origin' }).then((r) => r.ok, () => false));
